<template>
  <div style="width:100%;height:100%;position:relative;">
    <a-button
      style="z-index:1000;right:10px;bottom:10px;position:absolute;"
      type="primary"
      @click="exitCurrent()"
    >
      退出多窗口对比
    </a-button>
    <a-button
      style="z-index:1000;right:150px;bottom:10px;position:absolute;"
      type="primary"
      @click="closeBaseMap()"
    >
      {{isBaseMapVisible?'关闭底图':'开启底图'}}
    </a-button>
    <a-row
      type="flex"
      style="height:100%;position:relative;"
    >
      <a-col
        v-for="i in windowCount"
        :span="24/2"
        :key="i"
        :class="'dd-window-'+i+'-'+windowCount"
      >
        <div
          :id="'multiDiv'+i"
          class="dd-map"
        >
        </div>
        <a-select
          style="position:absolute;top:20px;left:10px;width:150px;z-index:1000;"
          :options="swipeLayers"
          :allowClear="true"
          placeholder="请选择图层"
          @change="layerChange($event,i)"
        >
        </a-select>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import "ol/ol.css";
import "ol-ext/dist/ol-ext.css";
import TileWMS from 'ol/source/TileWMS';
import { Map, View } from "ol";
import Projection from 'ol/proj/Projection';
import { register } from 'ol/proj/proj4';
import * as olControl from 'ol/control';
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Static from 'ol/source/ImageStatic';
import { Style, Fill, Stroke, Circle, Icon } from 'ol/style';
import Polygon from 'ol/geom/Polygon';
import Point from 'ol/geom/Point';
import { fromCircle } from 'ol/geom/Polygon';
import proj4 from 'proj4';
import Header from '@/components/Header';
import { getRenderPixel } from 'ol/render';
import epsg9900 from '../utils/epsgParams';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import WMTS from 'ol/source/WMTS';
import * as olProj from 'ol/proj';
import Synchronize from 'ol-ext/interaction/Synchronize';
import TileGrid from 'ol/tilegrid/TileGrid';
import XYZ from 'ol/source/XYZ';

export default {
  name: 'MultiWindow',
  data() {
    return {
      windowCount: 0,
      swipeLayers: [],
      allLayersMap: {},
      windowMap: [],
      selectedSwipLayer: {
        left: undefined,
        right: undefined
      },
      isBaseMapVisible: true,
      initSwipeExtent: epsg9900.initExtent,

    }
  },
  methods: {
    exitCurrent() {
      for (let i = 1; i < this.windowCount + 1; i++) {
        document.getElementById("multiDiv" + i).remove();
      }
      this.windowCount = 0;
      this.$emit("exitCurrent");
    },
    closeBaseMap() {
      this.windowMap.forEach(map1 => {
        const baseLayer = this.getWindowLayerById(map1, "base_layer_0");
        if (baseLayer) {
          baseLayer.setVisible(!baseLayer.getVisible());
        }
        this.isBaseMapVisible = baseLayer.getVisible();
      })
    },
    layerChange(val, whichMap) {
      if (val) {
        this.addSwipeWmsLayer(this.allLayersMap[val], whichMap);
      } else {
        const currentLayers = this.windowMap[whichMap].getLayers();
        currentLayers.forEach(l => {
          if (l.get("id") != "base_layer_0") {
            this.windowMap[whichMap].removeLayer(l);
          }
        })
      }
    },
    addBaseMap() {
      const projection = olProj.get('EPSG:990000');
      const tileSource = new XYZ({
        maxZoom: 8,
        minZoom: 0,
        projection: projection,
        transition: 0,
        tileGrid: new TileGrid({
          tileSize: 256,
          origin: epsg9900.origin,
          extent: epsg9900.extent,
          resolutions: epsg9900.tile_resolutions
        }),
        tileUrlFunction: (tileCoord) => {
          const z = "L" + this.zeroPad(tileCoord[0], 2, 10);
          const x = "C" + this.zeroPad(tileCoord[1], 8, 16);
          const y = "R" + this.zeroPad(tileCoord[2], 8, 16);
          return `${process.env.VUE_APP_BASEMAP}/Layers/_alllayers/${z}/${y}/${x}.png`;
        }
      })
      const baseLayer = new TileLayer({
        id: "base_layer_0",
        source: tileSource,
        wrapX: true
      });

      return baseLayer;
    },
    initSwipeMap() {
      const projection = olProj.get('EPSG:990000');
      for (let i = 1; i < this.windowCount + 1; i++) {
        const baseLayer = this.addBaseMap();
        this.windowMap[i] = new Map({
          target: 'multiDiv' + i,
          layers: [baseLayer],
          controls: olControl.defaults({
            zoom: false
          }),
          view: new View({
            projection: projection,
            center: [(epsg9900.initExtent[0] + epsg9900.initExtent[2]) / 2, (epsg9900.initExtent[1] + epsg9900.initExtent[3]) / 2],
            zoom: 16,
            minZoom: 12,
            maxZoom: 20
          })
        });
      }
      this.windowMap.forEach(map => {
        const sysncMaps = this.windowMap.filter(m => m != map);
        map.addInteraction(new Synchronize({ maps: sysncMaps }));
      });

    },
    addSwipeWmsLayer(layerInfo, position) {
      let tileLayer;
      if (this.isPngLayer(layerInfo.geometry_type)) {
        tileLayer = new ImageLayer({
          id: "windowLayer" + position,
          visible: true,
          source: new Static({
            url: `${process.env.VUE_APP_STATIC_ROOT + layerInfo.key}/${layerInfo.key + layerInfo.geometry_type}`,
            imageExtent: layerInfo.bbox,
            transition: 0
          })
        });
      } else {
        tileLayer = new TileLayer({
          visible: true,
          id: "windowLayer" + position,
          source: new TileWMS({
            url: process.env.VUE_APP_GEOSERVER_ROOT + "wms?",
            params: {
              'LAYERS': "chs:" + layerInfo.key,
              'TILED': true
            },
            serverType: 'geoserver',
            transition: 0
          })
        });
      }
      const currentLayers = this.windowMap[position].getLayers();
      currentLayers.forEach(l => {
        if (l.get("id") != "base_layer_0") {
          this.windowMap[position].removeLayer(l);
        }
      })
      this.windowMap[position].addLayer(tileLayer);
      this.windowMap[position].getView().fit(this.allLayersMap[layerInfo.key]["bbox"], this.windowMap[position].getSize())

    },
    isPngLayer(ext) {
      if (".png".toLowerCase() == ext || ".jpg".toLowerCase() == ext || ".jpeg".toLowerCase() == ext) {
        return true;
      }
      return false;
    },
    getWindowLayerById(map, id) {
      for (let l of map.getLayers().getArray()) {
        if (l.get("id") == id) {
          return l;
        }
      }
      return undefined;
    },
    zeroPad(num, len, radix) {
      let str = num.toString(radix || 10);
      while (str.length < len) {
        str = "0" + str;
      }
      return str;
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      this.$on("initMap", (allLayers, winCnt) => {
        self.$store.commit('setLoadingVisible', true);
        this.windowCount = winCnt;
        setTimeout(() => {
          this.allLayersMap = allLayers;
          this.swipeLayers = Object.keys(allLayers).map(key => {
            return { label: allLayers[key].name, value: allLayers[key].key };
          });

          this.initSwipeMap();
          self.$store.commit('setLoadingVisible', false);
        }, 1000);
      })
    })

  }
}
</script>
<style scoped>
.dd-map {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
}
.dd-window-1-2 {
  border-right: 3px solid rgb(103, 214, 252);
}
.dd-window-2-2 {
  border-left: 3px solid rgb(103, 214, 252);
}
.dd-window-1-4 {
  border-right: 3px solid rgb(103, 214, 252);
  border-bottom: 3px solid rgb(103, 214, 252);
}
.dd-window-2-4 {
  border-left: 3px solid rgb(103, 214, 252);
  border-bottom: 3px solid rgb(103, 214, 252);
}
.dd-window-3-4 {
  border-right: 3px solid rgb(103, 214, 252);
  border-top: 3px solid rgb(103, 214, 252);
}
.dd-window-4-4 {
  border-left: 3px solid rgb(103, 214, 252);
  border-top: 3px solid rgb(103, 214, 252);
}
</style>
<style lang="scss">
.ant-slider-rail {
  background-color: #888888;
}
.ol-target-overlay .ol-target:after,
.ol-target-overlay .ol-target:before {
  border: 1px solid rgb(103, 214, 252) !important;
}
</style>